import axios from '@app/config/axios.config';
import { getTablesParams } from '../apiType';
import { exportExcelFile } from '@app/system/utils/dataExporter';

export type PotentielsParrainagesModifie = {
    id: number;
    createdAt: string;
    updatedAt: string;
    raisonSociale: string;
    titre: string;
    prenom1: string;
    nom1: string;
    prenom2: string;
    nom2: string;
    adresse: string;
    cp: string;
    numeroPostal: string;
    localite: string;
    telephone1: string;
    telephone2: string;
    raisonSocialePj: string;
    libelleFacture: string;
    correspondance: string;
    accordDe: string;
    dateAccord: string;
    email: string;
    infosInternes: string;
    publicite: string;
    reconduction: boolean;
    annonceOk: boolean;
    ca: number;
    noClub: string;
    collaborateur: string;
};

export const getPotentielsParrainagesModifie = async (
    params: getTablesParams
): Promise<{
    result: PotentielsParrainagesModifie[];
    totalCount: number;
    aggregate: any;
}> => {
    try {
        const res = await axios.get('/potentiels-parrainages-modifie', {
            params,
        });
        return res.data;
    } catch (err) {
        console.error(err);
        return { result: [], totalCount: 0, aggregate: null };
    }
};

export const getPotentielsParrainagesModifieById = async (id: string) => {
    return await axios.get(`/potentiels-parrainages-modifie/${id}`);
};

export const getPotentielsParrainagesModifieByOriginalId = async (
    originalId: string
) => {
    return await axios.get(
        `/potentiels-parrainages-modifie/by-original/${originalId}`
    );
};

export interface CreatePotentielsParrainagesModifieBody {
    raisonSociale?: string;
    titre?: string;
    prenom1?: string;
    nom1?: string;
    prenom2?: string;
    nom2?: string;
    adresse?: string;
    cp?: string;
    numeroPostal?: string;
    localite?: string;
    telephone1?: string;
    telephone2?: string;
    raisonSocialePj?: string;
    libelleFacture?: string;
    correspondance?: string;
    accordDe?: string;
    dateAccord?: string;
    email?: string;
    infosInternes?: string;
    publicite?: string;
    reconduction?: boolean;
    annonceOk?: boolean;
    ca?: number;
    noClub?: string;
    collaborateur?: string;
    potentielsParrainagesId?: number;
}

export const createPotentielsParrainagesModifie = async (
    body: CreatePotentielsParrainagesModifieBody
) => {
    return await axios.post(`/potentiels-parrainages-modifie`, body);
};

export const validateAndCreateParrainage = async (id: string) => {
    return await axios.post(`/potentiels-parrainages-modifie/${id}/validate`);
};

export const validateAndCreateParrainageWithParams = async (
    id: string,
    mandatId: number,
    collaborateurId: number
) => {
    console.log(id, mandatId, collaborateurId);
    const res = await axios.post(
        `/potentiels-parrainages-modifie/${id}/validate`,
        {
            mandatId,
            collaborateurId,
        }
    );

    console.log('res -> ', res);

    exportExcelFile(
        res.data.factureReport.header,
        { tableData: res.data.factureReport.tableData },
        'Factures import report'
    );
    exportExcelFile(
        res.data.parrainageReport.header,
        { tableData: res.data.parrainageReport.tableData },
        'Parrainages import report'
    );

    return res;
};

export const updatePotentielsParrainagesModifie = async (
    id: string,
    body: CreatePotentielsParrainagesModifieBody
) => {
    return await axios.patch(`/potentiels-parrainages-modifie/${id}`, body);
};
